module.exports = __webpack_public_path__ + "img/k-ash-woman-front.dbf710cb.jpg";